import { IPanelProps } from '@fluentui/react';
import { StrictExtract, StrictOmit } from 'common/utilities/TypeHelpers';

import { NotificationSettingType } from './NotificationSettingsPanel/NotificationSettings.types';

export const OfficeShellPanelType = ['FamilySettings', 'PrivacySettings', 'NotificationSettings', 'GlobalCopilot'] as const;
export type OfficeShellPanelType = (typeof OfficeShellPanelType)[number];

export type OfficeShellPanelState =
  | {
      panelType: StrictExtract<OfficeShellPanelType, 'NotificationSettings'>;
      deepLinkParams?: {
        settingType: NotificationSettingType | undefined;
      };
    }
  | {
      panelType: StrictExtract<OfficeShellPanelType, 'FamilySettings'>;
      deepLinkParams?: Record<string, never>;
    }
  | {
      panelType: StrictExtract<OfficeShellPanelType, 'PrivacySettings'>;
      deepLinkParams?: Record<string, never>;
    }
  | {
      panelType: StrictExtract<OfficeShellPanelType, 'GlobalCopilot'>;
      deepLinkParams?: Record<string, never>;
    };

export type IOfficeShellPanelProps<PT extends OfficeShellPanelType> = IPanelProps &
  StrictOmit<Extract<OfficeShellPanelState, { panelType: PT }>, 'panelType'>;
